module.exports = __webpack_public_path__ + "img/logo_b2c.fd3bd1c4.png";